import React from "react";
import { Navigate } from "react-router-dom";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // logErrorToMyService(error, errorInfo);
    console.log("error: ", error);
    console.log("errorInfo: ", errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <Navigate to="/500" replace={true} />;
    }
    return this.props.children;
  }
}
